import { BLOCKED_CUSTOM_EVENT_PREFIX } from '../../constants/dataFieldKeys/reportColumnKeys';

export const isBlockedCustomEvent = (event: string): boolean => {
  return event.indexOf(BLOCKED_CUSTOM_EVENT_PREFIX) > -1;
};
